import { toast } from "react-hot-toast";

export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

//  CurrentMonth
export const CurrentMonth = monthNames[new Date().getMonth()];

//  CurrentYear
export const CurrentYear = () => {
  const date = new Date();
  return date.toLocaleString(date.getFullYear());
};

export const formatCurrency = (amount) => {
  const formatter = new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency: "NGN",
  });

  return formatter.format(amount);
};

export const formatDateTime = (dateTime) => {
  return new Date(dateTime).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(() => {
    toast.success("Data has been copied to clipboard.", {duration: 5000});
  });
};

